<div class="panel-container" [ngClass]="{'ets-hidden': !isActive}">
   <div class="toolbar">
      <div class="symbol-section">
         <ets-symbol-picker
               [showLastPrice]="false"
               [selectedInstrument]="selectedInstrument"
               (instrumentSelected)="onInstrumentSelected($event)">
         </ets-symbol-picker>
      </div>
      <div class="resolution-section">
         <dx-select-box
               class="tf-select"
               [items]="resolutions"
               valueExpr="value"
               displayExpr="label"
               [(value)]="resolution"
               (onValueChanged)="onResolutionChanged()">
         </dx-select-box>
         <dx-select-box
               class="ct-select"
               [items]="chartTypes"
               valueExpr="value"
               displayExpr="label"
               [(value)]="chartType"
               (onValueChanged)="onChartTypeChanged()">
         </dx-select-box>
      </div>
      <div class="drawing-section">
         <dx-button hint="Horizontal line" text="─" (onClick)="onDrawHorizontalLine()"></dx-button>
         <dx-button hint="Vertical line"   text="│" (onClick)="onDrawVerticalLine()"></dx-button>
         <dx-button hint="Trend line"      text="╱" (onClick)="onDrawTrendLine()"></dx-button>
         <dx-button hint="Clear all drawings" text="✕" type="danger" (onClick)="onClearDrawings()"></dx-button>
      </div>
      <div class="indicator-section">
         <dx-check-box
               text="MA"
               [(value)]="maEnabled"
               (onValueChanged)="onToggleMA()">
         </dx-check-box>
         <dx-number-box
               class="ma-period"
               hint="MA period"
               [min]="1"
               [max]="500"
               [showSpinButtons]="true"
               [disabled]="!maEnabled"
               [(value)]="maPeriod"
               (onValueChanged)="onMaPeriodChanged()">
         </dx-number-box>
         <dx-color-box
               class="swatch-only ma-color"
               hint="MA line color"
               [openOnFieldClick]="true"
               [showDropDownButton]="false"
               [disabled]="!maEnabled"
               [(value)]="maColor"
               (onValueChanged)="onMaColorChanged()">
         </dx-color-box>
      </div>
      <div class="indicator-section">
         <dx-check-box
               text="Pivots"
               [(value)]="pivotsEnabled"
               (onValueChanged)="onTogglePivots()">
         </dx-check-box>
         <dx-color-box
               class="swatch-only pv-color"
               hint="Pivot up color"
               [openOnFieldClick]="true"
               [showDropDownButton]="false"
               [disabled]="!pivotsEnabled"
               [(value)]="pivotUpColor"
               (onValueChanged)="onPivotUpColorChanged()">
         </dx-color-box>
         <dx-color-box
               class="swatch-only pv-color"
               hint="Pivot down color"
               [openOnFieldClick]="true"
               [showDropDownButton]="false"
               [disabled]="!pivotsEnabled"
               [(value)]="pivotDownColor"
               (onValueChanged)="onPivotDownColorChanged()">
         </dx-color-box>
      </div>
      <div class="nav-section">
         <dx-button hint="Jump to latest bars" text="▶|" (onClick)="onJumpToLatest()"></dx-button>
      </div>
   </div>
   <div class="chart-host">
      <ets-price-chart-canvas
            [componentId]="componentId"
            [ticker]="ticker"
            [resolution]="resolution"
            [chartType]="chartType"
            [maEnabled]="maEnabled"
            [maPeriod]="maPeriod"
            [maColor]="maColor"
            [pivotsEnabled]="pivotsEnabled"
            [pivotUpColor]="pivotUpColor"
            [pivotDownColor]="pivotDownColor"
            (overlaysChanged)="onOverlaysChanged($event)"
            (barsLoaded)="onBarsLoaded()">
      </ets-price-chart-canvas>
   </div>
</div>
